import type { NextPage } from 'next'

import { Card } from 'src/components/atoms/Card'
import { Heading1 } from 'src/components/atoms/Typography'
import { Page } from 'src/components/layouts/Page'
import { RegistryForm } from 'src/components/organisms/forms/RegistryForm'
import { HSpaceBetweenStack } from 'src/components/templates/HStack'
import { VStack } from 'src/components/templates/VStack'

import { NavigationContext } from 'src/types/account'
import { withAuthRequired } from 'src/utils/auth'

const CreateRegistry: NextPage = () => {
  return (
    <Page title='Create Registry' navigationContext={NavigationContext.Public}>
      <VStack>
        <HSpaceBetweenStack>
          <Heading1>Create registry</Heading1>
        </HSpaceBetweenStack>
        <Card className='overflow-x-scroll'>
          <RegistryForm />
        </Card>
      </VStack>
    </Page>
  )
}

export default withAuthRequired(CreateRegistry)
